<block>
    <block-title>
        {{ 'studyProgramme.label' | translate }}
    </block-title>
    <block-content>
        <listItems [list]="list" type="studyProgramme" compare="studyProgrammeComparison"></listItems>
    </block-content>
</block>

